/** Hand a generated file to the browser.
 *
 * The export endpoint returns the file's content rather than a URL, because
 * at the sizes a filtered list produces that is one round trip instead of
 * three (request, presign, fetch). ARCHITECTURE.md §3 documents an
 * S3-and-presigned-URL path for genuinely large exports — that is the route
 * to take when a report outgrows an API response, not before.
 */

export interface ExportedFile {
  filename: string
  content_type: string
  body: string
}

export function saveFile(file: ExportedFile): void {
  const blob = new Blob([file.body], { type: file.content_type })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = file.filename
  document.body.appendChild(a)
  a.click()
  a.remove()
  // Release it on the next tick — revoking immediately races the download
  // in some browsers and produces an empty file.
  setTimeout(() => URL.revokeObjectURL(url), 1000)
}
